import { currencySign } from 'common/helpers';

export const formatDonationAmount = (
    amount,
    currency,
    { isRecurring, recurringDuration } = { isRecurring: false },
) => {
    let result = `${currencySign(currency)}${parseFloat(amount).toLocaleString(
        'en-US',
        {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },
    )}`;
    const nbsp = '\u00A0';
    const recurringIndicator = 'x';
    if (isRecurring) {
        result = `${result}${nbsp}${recurringIndicator}${nbsp}${recurringDuration}`;
    }
    return result;
};
